import "./style.css";

export default function TituloNucleo({ nome, cidade, estado }) {
  if (!nome && !cidade) return null;

  return (
    <section className="titulo-nucleo">
      {nome && <h1 className="titulo-nucleo__nome">{nome}</h1>}
      {cidade && (
        <p className="titulo-nucleo__local">
          {cidade}
          {estado ? `, ${estado}` : ""}
        </p>
      )}
    </section>
  );
}
